import React from 'react';
import { Heading, PrimaryButton, TextField, SpinningLoader, useForm } from '@weave/design-system';
import { WeaveTheme } from '@weave/theme-original';
import { css } from '@emotion/core';
import { sectionContainerStyles } from '../fax-test-section.styles';

interface SendTestFaxFormProps {
  onSendFax: (faxNumber: string, onSuccess?: (faxId: string) => void) => void;
  isLoading: boolean;
  onFaxSent?: (faxId: string) => void;
}

export const SendTestFaxForm: React.FC<SendTestFaxFormProps> = ({
  onSendFax,
  isLoading,
  onFaxSent,
}) => {
  const { getFieldProps, values } = useForm({
    fields: {
      faxNumber: { type: 'text', value: '' },
    },
  });

  const handleSubmit = () => {
    const faxNumber = values.faxNumber?.trim() || '';
    onSendFax(faxNumber, onFaxSent);
  };

  return (
    <div css={sectionContainerStyles}>
      <Heading level={2} css={css`text-align: center !important; width: 100%;`}>
        Send Test Fax
      </Heading>

      <div css={(theme: WeaveTheme) => css`margin-bottom: ${theme.spacing(2)}; margin-top: ${theme.spacing(2)};`}>
        <TextField
          {...getFieldProps('faxNumber')}
          label="Fax Number (recipient)"
          placeholder="e.g., 8015133989"
        />
      </div>

      <PrimaryButton
        onClick={handleSubmit}
        disabled={isLoading}
      >
        {isLoading ? <SpinningLoader size="small" /> : 'Send Test Fax'}
      </PrimaryButton>
    </div>
  );
};
